/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFrown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.917 3.5a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm-10.25 8.75C1.667 6.59 6.256 2 11.917 2c5.66 0 10.25 4.59 10.25 10.25s-4.59 10.25-10.25 10.25c-5.661 0-10.25-4.59-10.25-10.25zm6.65-2.85a.75.75 0 01.75-.75h.01a.75.75 0 010 1.5h-.01a.75.75 0 01-.75-.75zm5.7 0a.75.75 0 01.75-.75h.01a.75.75 0 110 1.5h-.01a.75.75 0 01-.75-.75z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M8.735 14.71a5.846 5.846 0 013.182-.96c1.362 0 2.446.485 3.181.96.368.238.654.477.85.658a4.865 4.865 0 01.29.292l.018.021.006.007.002.003s.001.002-.466.396l.467-.394a.643.643 0 01-.98.83l-.002-.001.49-.415-.49.415.001.001-.007-.008a3.5 3.5 0 00-.204-.205 4.935 4.935 0 00-.673-.52 4.56 4.56 0 00-2.483-.754 4.56 4.56 0 00-2.484.754 4.938 4.938 0 00-.84.685l-.036.04-.007.008a.642.642 0 01-.982-.83l.491.414-.49-.414v-.002l.003-.003.006-.007.018-.02a4.873 4.873 0 01.29-.292c.196-.182.481-.42.85-.659z'
      />
    </svg>
  );
}

export default SvgFrown;
